import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { MotifButton, MotifCardFooter, MotifFormField, MotifInput, MotifOption, MotifSelect, MotifTextArea } from '@ey-xd/motif-react';
import { setValue } from '@microsoft/applicationinsights-core-js';

const PrivilegeForm = (props) => {
    const { onFormSubmit, onCancel, data } = props;

    const { control, setValue, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            privilegeName: '',
            status: 'Active',
            description: ''
        }
    });

    useEffect(() => {
        if (data) {
            setValue("privilegeName", data?.Privilege_name)
            setValue("status", data?.Privilege_status)
            setValue("description", data?.Privilege_Description)
        }
    }, [data])

    const onSubmit = (data) => {
        onFormSubmit(data);
    };

    return (
        <div>
            <div className="flex flex-col gap-2">
                <div className="flex gap-3 mb-3 !w-full">
                    <div className="sm:w-[100%] md:w-[40%] lg:w-[40%]">
                        <div>
                            <MotifFormField label="Privilege Name">
                                <Controller
                                    name="privilegeName"
                                    control={control}
                                    rules={{ required: 'Privilege name is required' }}
                                    render={({ field }) => (
                                        <MotifInput hideClearButton {...field} placeholder="Enter privilege name" />
                                    )}
                                />
                                {errors.privilegeName && <p>{errors.privilegeName.message}</p>}
                            </MotifFormField>

                            <MotifFormField label="Status">
                                <Controller
                                    name="status"
                                    control={control}
                                    render={({ field }) => (
                                        <MotifSelect {...field} placeholder="Select status" visibleOptions={3}>
                                            <MotifOption value="Active">Active</MotifOption>
                                            <MotifOption value="Inactive">Inactive</MotifOption>
                                        </MotifSelect>
                                    )}
                                />
                            </MotifFormField>
                        </div>
                    </div>
                    <div className="w-full">
                        <div>
                            <MotifFormField label="Description">
                                <Controller
                                    name="description"
                                    control={control}
                                    render={({ field }) => (
                                        <MotifTextArea {...field} placeholder="Enter description" />
                                    )}
                                />
                            </MotifFormField>
                        </div>
                    </div>
                </div>
                <hr style={{ opacity: "0.1" }} />
                <MotifCardFooter className="justify-end">
                    <MotifButton
                        onClick={onCancel}
                        type="button"
                        variant="secondary"
                        size="small"
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Cancel
                    </MotifButton>
                    <MotifButton
                        type="submit"
                        variant="primary"
                        size="small"
                        onClick={handleSubmit(onSubmit) as any}
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Save
                    </MotifButton>
                </MotifCardFooter>
            </div>
        </div>
    );
};

export default PrivilegeForm;
